(function () {
    'use strict';

    //  Requirements
    var $               = require('jquery');
    var classList       = require('../lib/class-list');
    var event           = require('../lib/event-handler');

    //  Variables
    var body            = document.body;
    var searchTrigger   = document.querySelector('.search-trigger');

    //  Events
    event.add(
        searchTrigger,
        'click',
        function (ev) {
            ev.preventDefault();
            classList.toggle(body, 'search-open');
            $('.menu-close').trigger('click');
        }
    );

    $('.menu-open').on('click', function (ev) {
        ev.preventDefault();
        classList.remove(body, 'search-open');
    });

    $('#s-main').on('click', function () {
        classList.remove(body, 'search-open');
    });

})();